import { Loader2 } from "lucide-react";

export const PageLoader = ({ label = "Loading…" }) => (
  <div
    className="flex flex-col items-center justify-center py-24 text-muted-foreground"
    data-testid="page-loader"
  >
    <Loader2 className="h-8 w-8 animate-spin text-blue-900" />
    <p className="text-sm mt-3">{label}</p>
  </div>
);
